import { Controller } from "@hotwired/stimulus"

// Refreshes the Grafana iframe src with a fresh JWT before the session expires.
// Grafana rotates tokens every 10 minutes; we refresh every 8 to stay ahead.
const REFRESH_INTERVAL_MS = 8 * 60 * 1000

export default class extends Controller {
  static targets = ["frame"]
  static values = { refreshUrl: String, grafanaPath: String }

  connect() {
    this.scheduleRefresh()
  }

  disconnect() {
    clearTimeout(this._timer)
  }

  scheduleRefresh() {
    this._timer = setTimeout(() => this.refresh(), REFRESH_INTERVAL_MS)
  }

  async refresh() {
    try {
      const response = await fetch(`${this.refreshUrlValue}?url=${encodeURIComponent(this.grafanaPathValue)}`, {
        headers: { Accept: "application/json", "X-CSRF-Token": this.csrfToken }
      })
      if (!response.ok) return
      const { url } = await response.json()
      if (url) this.frameTarget.src = url
    } catch (_) {
      // silently ignore network errors — next refresh will try again
    } finally {
      this.scheduleRefresh()
    }
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content ?? ""
  }
}
